import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appShow]',
  standalone: false
})
export class ShowDirective {
  constructor(private el: ElementRef, private rd: Renderer2) { }
  @Input() set appShow(value: boolean) {
    this.rd.setStyle(this.el.nativeElement, 'display', value === false ? 'none' : '');
  }
}
